import { LogWarning } from 'utils/logging';
import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import { triadSuperFetch } from 'utils/superFetch';
import { PublicEnvironmentVariables } from 'types';

const DEFAULT_RETRY = {
  maxAttempts: 3,
  waitTimeBetweenFails: 2000,
} as const;

interface GetApplicationLinksParams {
  sessionId: string;
  schoolCode: string;
  pageViewId: string;
  leadGuid: string;
  retry?: {
    maxAttempts: number;
    waitTimeBetweenFails: number;
  };
  env: PublicEnvironmentVariables;
}

interface GetApplicationLinksResponse {
  Links?: {
    ApplicationLink?: string;
  };
  SyStudentId?: string;
}

export async function getApplicationLinks({
  sessionId,
  schoolCode,
  pageViewId,
  leadGuid,
  retry = DEFAULT_RETRY,
  env,
}: GetApplicationLinksParams): Promise<{
  applicationLink: string;
  systudentId: string;
}> {
  const [apiError, response] =
    await triadSuperFetch<GetApplicationLinksResponse>(
      `${TRIAD_PROXY_ROUTE}/thankyoulinks`,
      {
        method: 'POST',
        timeout: env.configEnv === 'production' ? 5000 : 20000,
        retry,
        body: {
          sessionId,
          schoolCode,
          pageViewId,
          leadGuid,
        },
      }
    );

  if (apiError) {
    LogWarning('Error fetching application links', {
      description: apiError.message,
    });
    return { applicationLink: '', systudentId: '' };
  }

  return {
    applicationLink: response?.Links?.ApplicationLink ?? '',
    systudentId: response?.SyStudentId ?? '',
  };
}
